import { NgModule } from '@angular/core';
import { SiteAnnouncementComponent } from './site-announcement.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SafeStringModule } from '../../pipes/safe-string/safe-string.module';
import { SiteAnnouncementDialogComponent } from './site-announcement-dialog/site-announcement-dialog.component';
import { SafePipe } from '../../pipes/safe-string/safe.pipe';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        MatIconModule,
        MatDialogModule,
        SafeStringModule,
    ],
    declarations: [
        SiteAnnouncementComponent,
        SiteAnnouncementDialogComponent,
    ],
    providers: [
        SafePipe,
    ],
    exports: [SiteAnnouncementComponent]
})
export class SiteAnnouncementModule {
}
